"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var traverseSchema_1 = require("./traverseSchema");
var setDeepValue_1 = require("./setDeepValue");
function createCopy(dataLayer) {
    var copy = {};
    traverseSchema_1.traverseSchema(dataLayer, {
        onContainer: function (keyPath) { return setDeepValue_1.setDeepValue(copy, keyPath, {}); },
        onValue: function (keyPath, value) { return setDeepValue_1.setDeepValue(copy, keyPath, value); },
    });
    return copy;
}
exports.createCopy = createCopy;
